// Static SEO content generated by /app/scripts/generate_seo_pages.py (GPT-5.2)
// Read from JSON file at build time. The JSON is the source of truth.
import data from "./seo-pages.json";

export const SEO_CITIES = data.cities || {};
export const SEO_COMUNAS = data.comunas || {};
export const SEO_MODALITIES = data.modalities || {};

export const CITY_SLUGS = Object.keys(SEO_CITIES);
export const COMUNA_SLUGS = Object.keys(SEO_COMUNAS);
export const MODALITY_SLUGS = Object.keys(SEO_MODALITIES);

export function getCity(slug) {
    return SEO_CITIES[slug] || null;
}

export function getComuna(slug) {
    return SEO_COMUNAS[slug] || null;
}

export function getModality(slug) {
    return SEO_MODALITIES[slug] || null;
}
